export const getCurrentOrganization = state =>
  state.organizations.currentOrganization;
